
import * as Sentry from '@sentry/react'
import { initSentry } from './lib/sentry'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import { SentryErrorFallback } from './components/SentryErrorFallback'
import './index.css'

// Initialize Sentry before rendering the app
initSentry();

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={<SentryErrorFallback />}>
    <App />
  </Sentry.ErrorBoundary>,
);
